import styled from "@emotion/styled";
import { Button, Stack } from "@mui/material";
import { useTitle } from "../../../hooks/title";

export interface UnexpectedErrorProps {
  error: Error;
}

const ErrorDisplay = styled.div({
  code: {
    display: "block",
    marginBottom: "1em",
  },
  width: 1000,
  height: 200,
  overflowY: "scroll",
  backgroundColor: "#4d4d4d",
  color: "#DDD",
  padding: "1em",
  marginBottom: "2em",
});

export const UnexpectedError = ({ error }: UnexpectedErrorProps) => {
  useTitle("Unexpected Error · Imagio Color Finder");

  return (
    <Stack alignItems="center" spacing={2}>
      <h2>Unexpected Error</h2>
      <p>Unfortunately an unexpected Error occurred. Please reload the page.</p>
      <ErrorDisplay>
        <code>{error.message}</code>
        <code>{error.stack}</code>
      </ErrorDisplay>
      <Button variant="contained" href="/">
        Reload Page
      </Button>
    </Stack>
  );
};
